import sanityClientCtor from "picosanity"
import { WebAppConfig } from "../web-app-config"
import { stringIsPresent } from "../checks"

const sanityClient = (config: WebAppConfig) => {
    const showDraft = stringIsPresent(config.sanity.token)
    return sanityClientCtor({
        projectId: config.sanity.projectId,
        dataset: config.sanity.dataset,
        apiVersion: "2023-11-30",
        useCdn: !showDraft,
        token: config.sanity.token || undefined,
        perspective: showDraft ? "previewDrafts" : "published",
    })
}

export default sanityClient
